import { Button, Col, Image, Row, Typography } from 'antd';
import React, { FC } from 'react';
import checkEmailIcon from 'assets/icons/check-email.svg';
import styles from './styles.module.scss';

const { Title, Text } = Typography;

interface ICheckEmail {
  onOk: () => void;
}

export const CheckEmail: FC<ICheckEmail> = React.memo((props) => {
  const { onOk } = props;
  return (
    <Row justify="center" className={styles.check_email} gutter={[0, 24]}>
      <Image src={checkEmailIcon} alt="Icon" preview={false} />
      <Col span={24}>
        <Row justify="center" gutter={[0, 8]}>
          <Title className={styles.title}>Check your Email</Title>
          <Text className={styles.description}>Please check your email for password reset instructions.</Text>
        </Row>
      </Col>
      <Col span={24}>
        <Button type="primary" block onClick={onOk} size="large">
          Okay
        </Button>
      </Col>
    </Row>
  );
});
